import { IRenderProps, renderChildrenWithProps } from '../../utilities/components/RenderProps';
import { IWithWizardInjectedProps, withWizard, IDecorateWithWizardProps } from '../decorators/withWizard';
import * as React from 'react';

/**
 * @public
 */
export interface IWizardActionStateProps extends IWithWizardInjectedProps {
    // Nothing.
}

/**
 * @public
 */
export interface IWizardActionBaseProps extends IWithWizardInjectedProps, IRenderProps<IWizardActionStateProps> {
    // Nothing.
}

class WizardActionBase extends React.Component<IWizardActionBaseProps> {
    public render(): JSX.Element | null {
        const {
            children,
            ...wizardProps
        } = this.props;

        return renderChildrenWithProps(children, wizardProps);
    }
}

/**
 * @public
 */
export type IWizardActionProps = IDecorateWithWizardProps<IWizardActionBaseProps>;

/**
 * @public
 */
export const WizardAction: React.ComponentType<IWizardActionProps> = withWizard()(WizardActionBase);

/**
 * @public
 */
export const BackgroundAction: React.ComponentType<IWizardActionProps> =
    withWizard(undefined, {
        isBackgroundTask: true
    })(WizardActionBase);

/**
 * @beta
 */
export const HeadlessAction: React.ComponentType<IWizardActionProps> =
    withWizard(undefined, {
        isBackgroundTask: true,
        backgroundTaskScope: 'headless'
    })(WizardActionBase);
